export const networks = [
  {
    logo: require("@/assets/img/nav/icon_fb.svg"),
    link: "https://www.facebook.com/CervezaCartaBlanca",
    name: 'Facebook',
    social: true
  },
  {
    logo: require("@/assets/img/nav/icon_tw.svg"),
    link: "https://twitter.com/cartablancamx",
    name: 'Twitter',
    social: true
  },
  {
    logo: require("@/assets/img/nav/icon_youtube.svg"),
    link: "https://www.youtube.com/user/CartaBlancaTV",
    name: 'Youtube',
    social: true
  },
  {
    logo: require("@/assets/img/nav/icon_ig.svg"),
    link: "https://www.instagram.com/cartablancamx/",
    name: 'Instagram',
    social: true
  },
  {
    logo: require("@/assets/img/nav/icon_central.svg"),
    link:
      "https://centrall247.com/agegate?redirect=/hablemos-de-cerveza/carta-blanca",
    name: 'Central',
    social: false
  },
  {
    logo: require("@/assets/img/nav/SixToGo.svg"),
    link: "https://www.sixtogo.com.mx/carta-blanca",

    name: 'SixToGo',
    social: false
  },
];

export const items = [
  {
    path: "/",
    text: "HOME",
  },
  {
    path: "/cb-historia",
    text: "HISTORIA",
  },
  {
    path: "/cb-premios",
    text: "PREMIOS",
  },
  {
    path: "/cb-productos",
    text: "PRODUCTOS",
  },
  {
    path: "/cb-comercial",
    text: "CAMPAÑA",
  },
  {
    path: "/cb-donde-comprar",
    text: "DÓNDE COMPRAR",
  },
  {
    path: "https://fotografocartero.cartablanca.com.mx/rally/start",
    text: "FOTÓGRAFO CARTERO",
  },
];
